import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Modal, Row } from 'antd';
import Paragraph from '../../../components/common/Paragraph';
import enrollmentAction from '../../../providers/EnrollmentContextProvider/enrollmentAction';
import { EnrollmentContext } from '../../../providers/EnrollmentContextProvider';

const ExitButton = () => {
  const [isConfirmingExit, setConfirmingExit] = useState(false);

  const { dispatch } = useContext(EnrollmentContext);
  const history = useHistory();

  const cancelExit = () => setConfirmingExit(false);

  const openConfirmationModal = () => setConfirmingExit(true);

  const exit = () => {
    dispatch({ type: enrollmentAction.REMOVE_AUTH_TOKEN });
    history.push('/');
  };

  return (
    <>
      <Button type="primary" ghost onClick={openConfirmationModal}>
        Salir al inicio
      </Button>
      <Modal visible={isConfirmingExit} onCancel={cancelExit} footer={null}>
        <Paragraph align="center">
          ¿Estás seguro de que deseas salir al inicio?
          <br />
          Se eliminará toda la información ingresada.
        </Paragraph>
        <Row justify="center" gutter={8}>
          <Col span={6}>
            <Button type="primary" ghost onClick={cancelExit} block>
              Cancelar
            </Button>
          </Col>
          <Col span={6}>
            <Button type="primary" onClick={exit} block>
              Salir
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ExitButton;
